module.exports = __webpack_public_path__ + "771decc5028baf91516de409e6c11134.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/index_02.jpg
// module id = hDmz
// module chunks = 0